import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../../utils/commonfunction";
import * as reportedPostsServices from "../../../services/reportedPosts.services";
import { useTranslation } from "react-i18next";

const ReportedPostsView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Reported Posts"), url: "/admin/reportedPosts/list/1" },
    { title: t("link_view"), url: "" },
  ];

  useEffect(() => {
    reportedPostsServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  const renderPostImages = () => {
    const images =
      (showdefault?.post && (showdefault.post.images || showdefault.post.photos)) ||
      showdefault?.images ||
      [];

    if (!Array.isArray(images) || images.length === 0) {
      return "N/A";
    }

    const resolveSrc = (img) => {
      if (!img) return "";
      if (typeof img === "string") return img;
      if (typeof img === "object" && img.url) return img.url;
      return "";
    };

    return (
      <div className="d-flex flex-wrap gap-2">
        {images.map((img, index) => {
          const src = resolveSrc(img);
          if (!src) return null;
          return (
            <img
              key={index}
              src={src}
              alt="post"
              style={{
                width: "60px",
                height: "60px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #ddd",
                marginRight: "8px",
                marginBottom: "8px",
              }}
            />
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("Reported Post Details")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        {
                          showdefault?.post?.name ? 
                        <tr>
                          <th>{t("Post Title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.post?.name ? capitalizeFirstLetter(showdefault.post.name) : "N/A"}
                          </td>
                        </tr>
                        : null
                        }
                        <tr>
                          <th>{t("Post Caption")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.post?.caption ? capitalizeFirstLetter( showdefault.post.caption) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_images")}</th>
                          <td>{renderPostImages()}</td>
                        </tr>
                        <tr>
                          <th>{t("Reported By")}</th>
                          <td>
                            {showdefault && showdefault?.reportedBy
                              ? capitalizeFirstLetter(showdefault?.reportedBy?.full_name ||
                                showdefault?.reportedBy?.name ||
                                showdefault?.reportedBy?.username ||
                                showdefault?.reportedBy?.email ||
                                "N/A")
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Reason")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.reason ? capitalizeFirstLetter(showdefault.reason) : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("Additional Notes")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.additionalNotes ? showdefault.additionalNotes : "N/A"}
                          </td>
                        </tr> */}
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        {/* <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr> */}
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportedPostsView;
